<template>
    <div class="card-body">
        <form @submit.prevent="triggerSave">
            <div class="row">
                
                <!-- BLOCK 1: General Information (Basic Edit rights) -->
                <fieldset class="col-12 p-0" :disabled="!canEditGeneral">
                    <div class="row">
                        <!-- Profile Image -->
                        <div class="col-md-4 text-center">
                            <h3>Imagen de perfil</h3>
                            <img class="img-fluid rounded" style="width: 200px;" :src="img_perfil" alt="">
                            <br><br>
                            <input type="file" id="file" class="inputfile" @change="loadPhoto">
                            <label for="file"><i class="fas fa-upload"></i> Subir imagen </label>
                        </div>

                        <!-- Basic Info Fields -->
                        <div class="col-md-8">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label> No. Empleado </label>
                                        <input type="text" v-model="form.no_employee" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label> Nombre </label>
                                        <input type="text" v-model="form.name" class="form-control">
                                        <div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label> Apellidos </label>
                                        <input type="text" v-model="form.last_name" class="form-control">
                                        <div v-if="errors && errors.last_name" class="text-danger">{{ errors.last_name[0] }}</div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label> Teléfono </label>
                                        <input type="text" v-model="form.phone" class="form-control">
                                        <div v-if="errors && errors.phone" class="text-danger">{{ errors.phone[0] }}</div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label> WhatsApp </label>
                                        <input type="text" v-model="form.whathsapp" class="form-control">
                                        <div v-if="errors && errors.whathsapp" class="text-danger">{{ errors.whathsapp[0] }}</div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-group">
                                        <label> Email </label>
                                        <input type="mail" v-model="form.email" class="form-control">
                                        <div v-if="errors && errors.email" class="text-danger">{{ errors.email[0] }}</div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label> Fecha Ingreso </label><br>
                                        <date-picker v-model="form.admission_date" valueType="YYYY-MM-DD" format="DD-MM-YYYY" :clearable="false"></date-picker>
                                        <div v-if="errors && errors.admission_date" class="text-danger">{{ errors.admission_date[0] }}</div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label> Fecha de nacimiento </label>
                                        <date-picker v-model="form.birthday" valueType="YYYY-MM-DD" format="DD-MM-YYYY" :clearable="false"></date-picker>
                                        <div v-if="errors && errors.birthday" class="text-danger">{{ errors.birthday[0] }}</div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label> Área </label>
                                        <select v-model="form.area_id" class="form-control" @change="getUsersArea">
                                            <option value="">Seleccione...</option>
                                            <option :value="area.id" v-for="(area, index) in areas" :key="index">{{ area.name }}</option>
                                        </select>
                                        <div v-if="errors && errors.area_id" class="text-danger">{{ errors.area_id[0] }}</div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label> Perfil </label>
                                        <select v-model="form.profile_id" class="form-control">
                                            <option value="">Seleccione...</option>
                                            <option :value="cat_profile.id" v-for="(cat_profile, index) in profiles" :key="index">{{ cat_profile.name }}</option>
                                        </select>
                                        <div v-if="errors && errors.profile_id" class="text-danger">{{ errors.profile_id[0] }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12"><hr></div>

                        <!-- Address -->
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label> Dirección </label>
                                        <textarea v-model="form.address" class="form-control" rows="2"></textarea>
                                        <div v-if="errors && errors.address" class="text-danger">{{ errors.address[0] }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <!-- Sensitive Financial Data Block (Strict Edit rights) -->
                <fieldset class="col-12 p-0" :disabled="!canEditSensitive">
                    <div class="row">

                        <!-- Sensitive Financial Data -->
                        <div class="col-12" v-if="canViewSensitiveData">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label> Salario </label>
                                        <input type="text" v-model="form.salary" v-money="money" class="form-control">
                                        <div v-if="errors && errors.salary" class="text-danger">{{ errors.salary[0] }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- User Selectors (Boss/Authorizer) -->
                        <div class="col-md-6" v-if="showUsers">
                            <div class="form-group">
                                <label> Jefe Directo </label>
                                <multiselect v-model='form.user' :options='catalogue.users_area'
                                    :custom-label='postWithTitle' placeholder='Buscar usuarios' label='title'
                                    track-by='id' :multiple="false" :hide-selected="true"
                                    :loading="catalogue.users_area_load">
                                    <span slot="noResult">No se encontraron usuario con este nombre.</span>
                                </multiselect>
                                <div v-if="errors && errors.users_area" class="text-danger">{{ errors.users_area[0] }}</div>
                            </div>
                        </div>

                        <div class="col-md-6" v-if="showUsers">
                            <div class="form-group">
                                <label> Autorizador de Vacaciones </label>
                                <multiselect v-model='form.holidays_authorized_user' :options='catalogue.users_area'
                                    :custom-label='postWithTitle' placeholder='Buscar usuarios' label='title'
                                    track-by='id' :multiple="false" :hide-selected="true">
                                    <span slot="noResult">No se encontraron usuario con este nombre.</span>
                                </multiselect>
                                <div v-if="errors && errors.holidays_authorized_user_id" class="text-danger">{{ errors.holidays_authorized_user_id[0] }}</div>
                            </div>
                        </div>

                        <!-- Signature -->
                        <div class="col-12" v-if="canViewSensitiveData">
                            <div class="card">
                                <div class="card-body text-center" v-if="img_signature">
                                    <h4>Firma</h4>
                                    <img class="img-fluid rounded" :src="img_signature" alt="firma">
                                    <br>
                                    <button type="button" class="btn btn-sm btn-outline-info" @click="clearSignature()">
                                        <i class="fas fa-edit"></i> Subir de nuevo
                                    </button>
                                </div>
                                <div class="card-body text-center" v-else>
                                    <h4>Firma</h4>
                                    <vueSignature ref="signature1" :sigOption="option"></vueSignature>
                                    <hr>
                                    <button class="btn btn-sm btn-outline-info" type="button" @click="clear">
                                        <i class="fas fa-eraser"></i> Limpiar
                                    </button>
                                </div>
                                <div v-if="errors && errors.signature" class="text-danger text-center">{{ errors.signature[0] }}</div>
                            </div>
                        </div>

                        <div class="col-12" v-if="canViewSensitiveData">
                            <hr>
                        </div>
                    </div>
                </fieldset>

                <!-- BLOCK 2: Password (Enabled if canChangePassword) -->
                <fieldset class="col-12 p-0" :disabled="!canChangePassword" v-if="!newUser && canViewSensitiveData">
                     <div class="row">
                        <div class="col-md-12 mt-2">
                            <p class="text-info">Dejar en blanco si no quiere cambiar la contraseña</p>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label> Contraseña </label>
                                <div class="input-group">
                                    <input :type="type1" v-model="form.password" class="form-control">
                                    <div class="input-group-prepend">
                                        <div class="btn btn-outline-success" @click="type1 = type1 == 'password' ? 'text' : 'password'" style="border-radius: 0px 10px 10px 0px !important;">
                                            <i v-if="type1 == 'password'" class="fa-solid fa-eye"></i>
                                            <i v-else class="fa-solid fa-eye-slash"></i>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="errors && errors.password" class="text-danger">{{ errors.password[0] }}</div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label> Confirmar contraseña </label>
                                <div class="input-group">
                                    <input :type="type2" v-model="form.password_confirmation" class="form-control">
                                    <div class="input-group-prepend">
                                        <div class="btn btn-outline-success" @click="type2 = type2 == 'password' ? 'text' : 'password'" style="border-radius: 0px 10px 10px 0px !important;">
                                            <i v-if="type2 == 'password'" class="fa-solid fa-eye"></i>
                                            <i v-else class="fa-solid fa-eye-slash"></i>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="errors && errors.password_confirmation" class="text-danger">{{ errors.password_confirmation[0] }}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <hr>
                        </div>
                     </div>
                </fieldset>

                <!-- BLOCK 3: Extras & Buttons (Read Only context but Buttons outside) -->
                <!-- The buttons should NOT be disabled by the general read-only rule, otherwise we can't click Save if only changing password -->
                <!-- So we make the fields disabled, but the buttons separate -->
                
                <fieldset class="col-12 p-0" :disabled="!canEditGeneral">
                    <div class="row">
                        <div class="col-md-12" v-if="canViewSensitiveData">
                            <div class="form-group">
                                <label class="d-flex">
                                    <input type="checkbox" class="form-control form-control-sm mr-3" style="width: 20px;" v-model="form.privacy_notice">
                                    <span class="mt-1 mr-1">He leído y acepto el </span> <a href="https://www.soriano-ariza.com/privacy-notice" target="_black" class="mt-1 text-success"> aviso de privacidad</a>
                                </label>
                                <div v-if="errors && errors.privacy_notice" class="text-danger">{{ errors.privacy_notice[0] }}</div>
                            </div>
                        </div>

                        <div class="col-12" v-if="canViewSensitiveData">
                            <div class="row">
                                <div class="col-md-6 text-center">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label> Recordatorio Aniversario </label>
                                                <input type="checkbox" v-model="form.remember_anniversary" class="form-control">
                                                <hr>
                                                <p class="fs-6">Al activar esta opción se enviará una notificación por correo de felicitación de su aniversario cuando le toque</p>
                                                <div v-if="errors && errors.remember_anniversary" class="text-danger">{{ errors.remember_anniversary[0] }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 text-center">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label> Recordatorio Cumpleaños </label>
                                                <input type="checkbox" v-model="form.remember_birthdat" class="form-control">
                                                <hr>
                                                <p class="fs-6">Al activar esta opción se enviará una notificación por correo de felicitación de su cumpleaños cuando le toque</p>
                                                <div v-if="errors && errors.remember_birthdat" class="text-danger">{{ errors.remember_birthdat[0] }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <!-- Buttons Area - Always Enabled (logic controls visibility) -->
                <div class="col-md-12 mt-3">
                    <button v-if="canEditGeneral" type="submit" class="btn float-right btn-outline-success" :disabled="submitted">
                        <span v-if="submitted">
                            <i class="fa-solid fa-spinner fa-spin-pulse mr-1"></i> Enviando
                        </span>
                        <span v-else>
                            <i class="fas fa-save"></i> Guardar
                        </span>
                    </button>
                    <router-link to="/users" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i> Regresar
                    </router-link>
                </div>

            </div>
        </form>
    </div>
</template>

<script>
import request from '@/services/request'
import { mapActions, mapGetters } from 'vuex';

import Catalogue from '@/services/catalogue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import { checkPermission } from '@/helpers/acl';
import vueSignature from "vue-signature"
import Multiselect from 'vue-multiselect'


export default {
    name: "profile-user",
    components: {
        DatePicker,
        vueSignature,
        Multiselect
    },
    props: ['userId'],
    data() {
        return {
            form: {
                id: '',
                name: '',
                last_name: '',
                no_employee: '',
                img_perfil: '',
                phone: '',
                whathsapp: '',
                profile_id: '',
                area_id: '',
                email: '',
                birthday: '',
                admission_date: '',
                user_id: '',
                user: '',
                approve_holidays_rh: '',
                remember_anniversary: '',
                remember_birthdat: '',
                password: '',
                password_confirmation: '',
                privacy_notice: false,
                holidays_authorized_user_id: '',
                holidays_authorized_user: '',
                // New financial fields
                salary: '',
                workday_type: '',
                gender: '',
                nationality: '',
                marital_status: '',
                address: '',
                education_level: '',
                degree_title: '',
                english_level: '',
                checador_enabled: true
            },
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            showUsers: false,
            area: '',
            areas: [],
            profiles: [],
            img_perfil: require('@/assets/img/profile.png'),
            img_signature: '',
            errors: {},
            catalogue: new Catalogue(),
            option: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgba(255,255,255, 0)"
            },
            profile: {},
            load_user: false,
            type1: 'password',
            type2: 'password',
            submitted: false,
            newUser: false,
            type: 1,
        }
    },
    mounted() {
        // Debug Permissions
        console.log("---------------- PERMISSION DEBUG ----------------");
        console.log("Auth User ID:", this.authUser.id);
        console.log("Target Profile ID:", this.userId);
        console.log("Has 'edit_users' permission?:", checkPermission('edit_users'));
        console.log("Has 'edit_users' permission?:", checkPermission('edit_users'));
        console.log("computed canEditGeneral:", this.canEditGeneral);
        console.log("computed canEditSensitive:", this.canEditSensitive);
        console.log("computed canChangePassword:", this.canChangePassword);
        console.log("--------------------------------------------------");

        let is_new = this.authUser.new;
        if (this.userId == this.authUser.id && is_new == 1) {
            this.$swal({
                title: 'Información requerida',
                text: 'Es necesario completar los datos del perfil para continuar',
                icon: 'warning',
                confirmButtonText: 'Entendido',
            });
        }
        this.getProfiles();
        this.getAreas();
        let id = this.$route.params.id;
        if (id) {
            this.get_id(id);
        }
    },
    methods: {
        clear() {
            var _this = this;
            _this.$refs.signature1.clear();
        },
        clearSignature() {
            console.log('paso');
            this.img_signature = '';
        },
        loadPhoto(event) {
            if (event.target.files[0].type == "image/png" ||
                event.target.files[0].type == "image/jpeg") {
                this.form.img_perfil = event.target.files[0];
                this.img_perfil = URL.createObjectURL(event.target.files[0]);
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PNG , JPGE',
                });
            }
        },
        postWithTitle(option) {
            let name = '';
            if (option.name) {
                name += option.name;
            }
            if (option.last_name != null && option.last_name != "" && option.last_name != "null") {
                name += ' ' + option.last_name;
            }
            return name;
        },
        async triggerSave() {
            this.submitted = true;
            let signature = "";

            if (this.$refs.signature1) {
                const _empty = await this.$refs.signature1.isEmpty();
                if (!_empty) {
                    signature = this.$refs.signature1.save();
                }
            }

            const data_form = new FormData();
            data_form.append('id', this.form.id);
            data_form.append('name', this.form.name);
            data_form.append('last_name', this.form.last_name);
            data_form.append('email', this.form.email);
            data_form.append('phone', this.form.phone);
            data_form.append('profile_id', this.form.profile_id);
            data_form.append('area_id', this.form.area_id);
            data_form.append('img_perfil', this.form.img_perfil);
            data_form.append('whathsapp', this.form.whathsapp);
            data_form.append('birthday', this.form.birthday);
            data_form.append('admission_date', this.form.admission_date);
            data_form.append('password', this.form.password);
            data_form.append('password_confirmation', this.form.password_confirmation);
            data_form.append('privacy_notice', this.form.privacy_notice ? 1 : 0);
            data_form.append('remember_anniversary', this.form.remember_anniversary ? 1 : 0);
            data_form.append('remember_birthdat', this.form.remember_birthdat ? 1 : 0);
            data_form.append('checador_enabled', this.form.checador_enabled ? 1 : 0);
            data_form.append('type', this.form.type);
            if (this.form.user) {
                data_form.append('user_id', this.form.user.id);
            } else {
                data_form.append('user_id', this.form.user_id);
            }

            if (this.form.holidays_authorized_user) {
                data_form.append('holidays_authorized_user_id', this.form.holidays_authorized_user.id);
            } else {
                data_form.append('holidays_authorized_user_id', this.form.holidays_authorized_user_id);
            }

            // Append new financial fields
            data_form.append('salary', this.form.salary);
            data_form.append('workday_type', this.form.workday_type);
            data_form.append('gender', this.form.gender);
            data_form.append('nationality', this.form.nationality);
            data_form.append('marital_status', this.form.marital_status);
            data_form.append('address', this.form.address);
            data_form.append('education_level', this.form.education_level);
            data_form.append('degree_title', this.form.degree_title);
            data_form.append('english_level', this.form.english_level);


            if (signature) {
                data_form.append('signature', signature);
            }

            let _endpoint = '/users';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/users/${this.form.id}`;
            }

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    // If editing own profile, reload auth user
                    if (this.userId == this.authUser.id) {
                        await this.authRelaod();
                    }
                    
                    // this.users = data.data;
                    await this.successNotification(data.message);
                    this.submitted = false;
                    
                    // Redirect logic
                    if (this.userId == this.authUser.id) {
                         // Stay or go to home?
                         await this.$router.push('/');
                    } else {
                         // Admin editing another user -> Go back to users list
                         await this.$router.push('/users');
                    }
                }
            } catch (error) {
                this.submitted = false;
                this.errors = {};
                if (error.response) {
                    let info_error = await this.errorNotification(error);
                    if (info_error == 'Logout') {
                        this.$nextTick(() => {
                            location.reload()
                        })
                    } else {
                        this.errors = info_error;
                    }
                }
            }
        },
        async get_id(id) {
            let _endpoint = `/users/${id}`;
            try {
                let { data } = await request.get(_endpoint)
                if (data) {
                    console.log(data);
                    this.form.id = id;
                    this.form.name = data.name ? data.name : '';
                    this.form.last_name = data.last_name ? data.last_name : '';
                    this.form.img_perfil = data.img_perfil ? data.img_perfil : '';
                    this.form.no_employee = data.no_employee ? data.no_employee : '';
                    this.form.phone = data.phone ? data.phone : '';
                    this.form.whathsapp = data.whathsapp ? data.whathsapp : '';
                    this.form.email = data.email ? data.email : '';
                    this.form.profile_id = data.profile_id ? data.profile_id : '';
                    this.form.area_id = data.area_id ? data.area_id : '';
                    
                    // Load users for the selected area
                    if (this.form.area_id) {
                        this.showUsers = true;
                        this.catalogue.get_users_area(this.form.area_id, this.form.id);
                    }

                    this.form.birthday = data.birthday ? data.birthday : '';
                    this.form.admission_date = data.admission_date ? data.admission_date : '';
                    this.form.user_id = data.user_id ? data.user_id : '';
                    this.form.approve_holidays_rh = data.approve_holidays_rh == 1 ? true : false;
                    this.form.remember_anniversary = data.remember_anniversary == 1 ? true : false;
                    this.form.remember_birthdat = data.remember_birthdat == 1 ? true : false;
                    
                    // Map new financial fields
                    this.form.salary = data.salary ? data.salary : '';
                    this.form.workday_type = data.workday_type ? data.workday_type : '';
                    this.form.gender = data.gender ? data.gender : '';
                    this.form.nationality = data.nationality ? data.nationality : '';
                    this.form.marital_status = data.marital_status ? data.marital_status : '';
                    this.form.address = data.address ? data.address : '';
                    this.form.education_level = data.education_level ? data.education_level : '';
                    this.form.degree_title = data.degree_title ? data.degree_title : '';
                    this.form.english_level = data.english_level ? data.english_level : '';
                    if (data.profile_picture) {
                        try {
                            this.img_perfil = await this.fileS3(data.profile_picture, false);
                        } catch (error) {
                            console.error("Error loading profile picture:", error);
                        }
                    }
                    
                    if (data.signature) {
                        try {
                            this.img_signature = await this.fileS3(data.signature, true);
                        } catch (error) {
                            console.error("Error loading signature:", error);
                        }
                    }
                    
                    if (data.profile) {
                        this.profile = data.profile;
                    }
                    this.form.user = data.user;
                    this.form.holidays_authorized_user = data.holidays_authorized_user;
                    this.form.holidays_authorized_user_id = data.holidays_authorized_user_id ? data.holidays_authorized_user_id : '';
                    this.newUser = data.new == 1 ? true : false;
                    this.form.privacy_notice = data.privacy_notice == 1 ? true : false;
                    this.form.checador_enabled = data.checador_enabled == 1 ? true : false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error)
                }
            }
        },
        async fileS3(file, signature = false){
            if (!file) return null;

            try {
                let _endpointSignature = `/get_url_file/${file}/files/${signature}`;
                console.log(_endpointSignature);

                let { data } = await request.get(_endpointSignature);
                console.log("Respuesta completa:", data);

                return data && data.url ? data.url : null;
            } catch (error) {
                console.error("Error al obtener el archivo:", error);
                throw error;  // No necesitas `Promise.reject`, solo lanza el error
            }

        },
        async getProfiles() {
            let service = request;
            let _endpoint = '/catalogue/profiles_list';
            try {
                let { data } = await service.get(_endpoint)
                if (data) {
                    this.profiles = data;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error)
                }
            }
        },
        getUsersArea() {
            if (this.form.area_id) {
                this.showUsers = true;
                this.catalogue.get_users_area(this.form.area_id, this.form.id);
            } else {
                this.showUsers = false;
            }
        },
        async getAreas() {
            let service = request;
            let _endpoint = '/catalogue/areas';
            try {
                let { data } = await service.get(_endpoint)
                if (data) {
                    this.areas = data;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error)
                }
            }
        },
        clearUser() {
            this.form.user = '';
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
            authRelaod: 'auth/getUser'

        })
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        }),
        canViewSensitiveData() {
            return (this.userId == this.authUser.id) || checkPermission('sensitive_data');
        },
        canEditGeneral() {
            // Can edit if has permission OR is own profile
            return checkPermission('edit_users') 
            // || this.userId == this.authUser.id;
        },
        canEditSensitive() {
            // STRICT: Must have edit permission AND sensitive data permission
            // Being the owner is NOT enough to bypass this redundancy check if sensitive data is involved
            return checkPermission('edit_users') && checkPermission('sensitive_data');
        },
        canChangePassword() {
            // Can change password if canEditGeneral (admin/owner)
            return this.canEditGeneral || this.userId == this.authUser.id;
        }
    },
    watch: {
        // Watch for userId prop changes (when used from TabsProfile)
        userId: {
            immediate: true,
            handler(newId) {
                if (newId) {
                    this.get_id(newId);
                }
            }
        }
    },
}
</script>

<style scoped>
.pagination {
    margin-bottom: 0;
}

.mx-datepicker {
    width: 100%;
}

.fs-6 {
    font-size: 12px;
}

.custom-file-label::after {
    content: "Archivo";
}

.text-success {
    color: #19692c !important;
}
</style>